import { doArticleRecord, doReportRecord } from "@/components/articleComponent/js"
import { downLoad, get, post, downLoadPost, getBody } from '@/axios/index'
import { saveAs } from 'file-saver';

const downloadRes = async (url,fileName) => {

    // var element = document.createElement('a');
    // element.href = url;
    // var encodedFileName = encodeURIComponent(fileName); // 对文件名进行 URL 编码

    // element.setAttribute('download', decodeURIComponent(encodedFileName));  // 强制下载
    // element.style.display = 'none';
    // document.body.appendChild(element);
    // element.click();
    // document.body.removeChild(element);
    console.log(getBlobOfUrl(url))
    getBlobOfUrl(url).then((blob)=>{
        console.log(blob)
        const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName; // 指定文件下载名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url); // 释放临时 URL
      message.success('下载成功')

    })
    

   }

/**
 * @method 同时下载多文件,并生成一个压缩包
 * @param { Object[] } fileInfoList - 文件列表
 * @param { String } urlField - 文件URL的字段名
 * @param { String } fileNameField - 文件名的字段名
 * @param { String } folderName - 压缩包 & 文件夹名称
 */
const   downloadAsZip=(
    fileInfoList,
    folderName ,
  )=> {
    return new Promise((resolve, reject) => {
      const zip = new JSZip();
      // const folder = zip.folder(folderName); // 创建文件夹
      const promisesList = fileInfoList.map((item) => {
        return getBlobOfUrl(item.attachmentUrl)
          .then((data) => {
            // console.log(data); // Blob
            // folder.file(item[fileNameField], data, { binary: true }); // 往文件夹中存放文件
            var  filetType =getFileExtensionFromMimeType(data.type)
            zip.file(item.attachmentName.split('/').pop()+filetType, data, { binary: true }); // 不创建文件夹
          })
          .catch((e) => {
            console.log(e);
            message.warning(e?.message || '获取文件流失败')
          });
      });
      Promise.all(promisesList)
        .then(() => {
          zip
            .generateAsync({ type: 'blob' })
            .then((content) => {
              saveAs(content, folderName);
              message.success('下载成功')
              resolve('success');
            })
            .catch((e) => {
              message.warning(e?.message || '生成压缩包失败')
              reject(e);
            });
        })
        .catch((e) => {
          message.warning(e?.message || '批量获取文件流失败')
          reject(e);
        });
    });
  }
  const  getFileExtensionFromMimeType=(mimeType)=> {
    const mimeToExtensionMap = {
      'application/pdf': '.pdf',
      'image/jpeg': '.jpg',
      'image/png': '.png',
      'text/plain': '.txt',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
      'application/vnd.ms-excel': '.xls',
      'application/msword': '.doc',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
      'application/zip': '.zip',
      'application/json': '.json',
    };
    return mimeToExtensionMap[mimeType] || ''; // 如果未匹配到，返回空字符串
  }

  /**
   * @method 根据文件URL获取blob数据流的API
   * @param { String } fileUrl - 文件完整路径，如：http://xxx.png
   */
const  getBlobOfUrl=(fileUrl)=> {
    return   new Promise((resolve, reject) => {
        fetch(fileUrl)
        .then(response => response.blob())
        .then(blob => {
            resolve(blob)
        }).catch((erro)=>{
            reject(erro)
        })
      })
  
  }
export const openDocumentAll=( fileInfoList, folderName )=>{
    downloadAsZip( fileInfoList,
        folderName)
}
export const openDocument = (id, val,fileName,type) => {
    if (id)
        doReportRecord({ id: id, data: { companyId: store.getters.company.companyId, type: 0 } }).then(() => {
            
            window.open(val, '_blank')
            // downloadRes(val,fileName)
        })
    else{
        if(type==0)  window.open(val, '_blank')
            else         
        downloadRes(val,fileName)
    }
        
}
import store from "@/store"
import JSZip from "jszip";
import { message } from "ant-design-vue/lib/components";
export const toDoArticleRecord = (val, type) => {
    doArticleRecord({ id: val, data: { companyId: store.getters.company.companyId, type: type, handlerPlatform: 1 } }).then(() => {
    })
}
const api = '/mini'
export const getDefaultKeyword=(p)=>post(api + '/article/keyword/'+p)
export const getReadList = (p) => get(api + '/clientRecord', p)

export const downLoadReadList = (p) => downLoad(api + '/clientRecordDownload', p)
export const getSearchMind = (p) => get(api + '/searchMind', p)
export const getCompanyTaxNo = (p) => get(api + '/companyTaxNo', p)
export const getClientInvoiceList = (p) => get(api + '/clientInvoiceList', p)
export const postSetClientInvoice = (p) => post(api + '/setClientInvoice', p)
export const getPayingGroupClient = (p) => get(api + '/getPayingGroupClient', p)
export const removePayingGroupByCompanyIds = (p) => get(api + '/removePayingGroupByCompanyIds', p)
export const getMiniKeywords = (p) => get(api + "/getKeywords", p)

export const reportArticleList = (p) => post(api + "/reportArticleList", p)

//修改关键词
export const postSetMiniKeyword = (p) => post(api + '/setCompanyArticlePoolKeyword', p)


const api1 = '/article'

export const exportPageList = (p) => get(api1 + '/doc/page', p)


export const exportItem = (p) => downLoad(api1 + '/doc/export', p)





const api2 = "/pc"
export const searchUserList = (p) => get(api2 + '/companyAdminFindClient', p)

export const companyAdminOperateClient = (p) => post(api2 + '/companyAdminOperateClient', p)
export const selectArticleCategory = (p) => get(api2 + '/selectArticleCategory', p)
export const getCategoryList = (p) => get(api2 + '/categoryList', p)
export const setArticleCategory = (p) => post(api2 + '/setArticleCategory', p)
const api3 = "/articleRecord"
export const allCommentPage = (p) => post(api3 + '/allCommentPage', p)
export const downloadComment = (p) => downLoadPost(api3 + '/downloadComment', p)

export const getApp = (p) => get( '/torchV/getApp', p)
export const modifyPassword= (p) => post( '/mini/modifyPassword', p)
